import { config } from "../../config"

const games = {
  Crosswords: {
    Post: ({ token, name, size, entries }) => {
      const url = config.apiUrl + `/games/crosswords`,
        opt = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            config: {
              size,
              entries,
            },
          }),
        }

      return { url, opt }
    },
  },

  Wordsearch: {
    Generate: ({ tag, size, orientations, difficulty }) => {
      const url =
          config.apiUrl +
          `/games/wordsearch/generate?tag=${tag}&size=${size}&orientations=${orientations}&difficulty=${difficulty}`,
        opt = {
          method: "GET",
        }

      return { url, opt }
    },

    Post: ({ token, name, size, diff, text }) => {
      const url = config.apiUrl + `/games/wordsearch`,
        opt = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            config: {
              diff,
              size,
              text,
            },
          }),
        }

      return { url, opt }
    },
  },

  Grammar: {
    Generate: ({ diff = "easy", length = 5, types }) => {
      let url =
          config.apiUrl +
          `/games/grammar/generate?diff=${diff}&length=${length}`,
        opt = {
          method: "GET",
        }

      if (types !== null && types !== "" && types !== "*")
        url += `&types=${types}`

      return { url, opt }
    },
  },

  SeaAnimals: {
    Generate: ({ size = 6 }) => {
      let url = config.apiUrl + `/games/seaanimals/generate?size=${size}`,
        opt = {
          method: "GET",
        }

      // if (types !== null && types !== "" && types !== "*")
      //   url += `&types=${types}`

      return { url, opt }
    },
  },

  Memory: {
    Random: ({ category, difficulty }) => {
      const url =
          config.apiUrl +
          `/games/memory/random?cat=${category}&diff=${difficulty}`,
        opt = {
          method: "GET",
        }

      return { url, opt }
    },
  },

  GuessWord: {
    generate: ({ difficulty , type}) => {
      let url = config.apiUrl + `/games/guessword/generate?difficulty=${difficulty}&type=${type}`,
        opt = {
          method: "GET",
        }
      return { url, opt }
    },
    get_similarity: (word1, word2) => {
      let url = config.apiUrl + `/games/guessword/get_similarity?word1=${word1}&word2=${word2}`,
        opt = {
          method: "GET",
        }
      return { url, opt }
    },
  },

  Story: {
    Generate: ({ id }) => {
      let url = config.apiUrl + `/games/story/generate?id=${id}`,
        opt = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      return { url, opt }
    },
    listStories: () => {
      let url = config.apiUrl + `/stories`,
        opt = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      return { url, opt }
    },
  },

  read_all: () => {
    const url = config.apiUrl + `/games`,
      opt = {
        method: "GET",
      }

    return { url, opt }
  },

  getCreatedGames: ({ token }) => {
    const url = config.apiUrl + `/games/byme`,
      opt = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }

    return { url, opt }
  },

  delete: ({ token, game_id }) => {
    const url = config.apiUrl + `/games/${game_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  About: {
    Generate: ({ starting_letter }) => {
      const url = new URL(`${config.apiUrl}/games/about/generate`)
      url.searchParams.set("starting_letter", starting_letter)
      const opt = {
        method: "GET",
      }

      return { url, opt }
    },
  },
}

export { games }
